import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";

/*Reorganizados*/

/* Metodos Principales */
export const alternativeStartRegisterAdmin = (alternative, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ALTERNATIVE}`,
      "add",
      alternative,
      "POST"
    );

    const body = await resp.json();
   
     debugLogActions(':: alternativeActions, alternativeStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const alternativeSaved = body.alternative;

      dispatch(alternativeRegisterAdmin(alternativeSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-alternative";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const alternativeRegisterAdmin = (alternative) => ({
  type: types.ALTERNATIVE_START_REGISTER_ADMIN,
  payload: alternative,
});

export const alternativeStartUpdate = (alternative, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_ALTERNATIVE}`,
        `update/${alternative.id}`,
        alternative,
        "PUT"
      );
      const body = await resp.json();

        debugLogActions(':: alternativeActions, alternativeStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(alternativeUpdated(alternative));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          debugLogActions("inside errors", body.errors);
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: alternativeActions, alternativeStartUpdate', { 'error': error });
    }
  };
};

const alternativeUpdated = (alternative) => {
  return {
    type: types.ALTERNATIVE_UPDATE,
    payload: alternative,
  };
};

export const alternativeStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_ALTERNATIVE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              debugLogActions(':: alternativeActions, alternativeStartRegisterAdmin', { 'body': body });
               debugLogActions('---> startGetRolesMenusByUserId', { 'body': body });

              if (body.ok) {
                dispatch(alternativeDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: alternativeActions, alternativeStartDelete', { 'error': error });
    }
  };
};

const alternativeDeleted = (id) => {
  return {
    type: types.ALTERNATIVE_DELETE,
    payload: id,
  };
};

export const startLoadingAlternativesPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'alternative');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_ALTERNATIVE}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

     debugLogActions(':: alternativeActions, startLoadingAlternativesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingAlternativesPaginated(body.alternativesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingAlternativesPaginated = (alternativesPaginated) => ({
  type: types.ALTERNATIVE_START_LOADING_PAGINATED,
  payload: alternativesPaginated,
});

export const startLoadingAlternativesByTextAlternativePaginated = (alternative, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

    const searchInfo = {
      searchAlternativeText: alternative,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    //console.log("9, searchInfo en actions", searchInfo);

    dispatch(alternativeIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ALTERNATIVE}`,
      `getByTextAlternative/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

      debugLogActions(':: alternativeActions, startLoadingAlternativesByTextAlternativePaginated', { 'body': body });
    if (body.ok) {

      dispatch(alternativeIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.alternativesPaginated.alternativesP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingAlternativesByTextAlternativePaginated(body.alternativesPaginated));

      const { totalItems, totalPages, currentPage, alternativesP } = body.alternativesPaginated;
      
            let index = 0;
            let registerIds = "";
            alternativesP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(alternativeIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingAlternativesByTextAlternativePaginated = (alternativesPaginated) => ({
  type: types.ALTERNATIVE_START_LOADING_ALTERNATIVE_PAGINATED,
  payload: alternativesPaginated,
});

export const startSearchingAlternativesPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'alternative');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ALTERNATIVE}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

      debugLogActions(':: alternativeActions, loadingAlternativesByTextAlternativePaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingAlternativesPaginated(body.alternativesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingAlternativesPaginated = (alternativesPaginated) => ({
  type: types.ALTERNATIVE_START_SEARCH_PAGINATED,
  payload: alternativesPaginated,
});

export const selectAlternative = (alternative) => ({
  type: types.ALTERNATIVE_SELECT,
  payload: alternative,
});

export const cleanAlternativesPaginatedS = () => ({
  type: types.ALTERNATIVE_CLEAN_SEARCH_PAGINATED,
});

export const cleanAlternativesPaginatedP = () => ({
  type: types.ALTERNATIVE_CLEAN_PAGINATED,
});

export const alternativeSetSearchText = (searchText) => ({
  type: types.ALTERNATIVE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const alternativeCleanSearchText = () => ({
  type: types.ALTERNATIVE_CLEAN_SEARCH_TEXT,
});

export const alternativeCleanSaved = () => ({
  type: types.ALTERNATIVE_CLEAN_SAVED,
});

//Si van update 13 de Febrero 2026
export const alternativeListUpdateSelected = (id) => ({
  type: types.ALTERNATIVE_LIST_UPDATE_SELECTED,
  payload: id
});

export const alternativeListSelectAllLimit = () => ({
  type: types.ALTERNATIVE_SELECT_ALL_LIMIT,
});

export const alternativeCleanAllSelected = () => ({
  type: types.ALTERNATIVE_CLEAN_ALL_SELECTED,
});

export const alternativeCleanAllSelectedWithoutList = () => ({
  type: types.ALTERNATIVE_CLEAN_ALL_WITHOUT_LIST,
});

export const alternativeIsLoading = () => ({
  type: types.ALTERNATIVE_IS_LOADING
});

export const alternativeIsLoadingFinish = () => ({
  type: types.ALTERNATIVE_IS_LOADING_FINISH
});

//No van Update 13 de Febrero 2026
export const alternativeGetMoreThanOneIsSelected = () => ({
  type: types.ALTERNATIVE_GET_MORE_THAN_ONE_SELECTED
});

export const alternativeGetNumberAlternativeSelected = (countCompareFlag) => ({
  type: types.ALTERNATIVE_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.ALTERNATIVE_CLEAN_SEARCH_INFORMATION,
});